import React, { useEffect } from 'react'

import { Spinner } from '@wartek-id/spinner'

import { NotFoundError } from 'utils/customError'
import { useKinerjaHarianActive } from 'app/KinerjaHarian/hooks/useKinerjaHarianActive'

export function PageGuardKinerjaHarian({
  children,
}: {
  children: React.ReactNode
}) {
  const { isActive, isPerencanaanReady, isLoading } = useKinerjaHarianActive()

  useEffect(() => {
    if (!isLoading && !(isActive && isPerencanaanReady)) {
      throw new NotFoundError('', null)
    }
  }, [isActive, isPerencanaanReady, isLoading])

  if (isLoading) {
    return (
      <div className="flex p-10">
        <div className="m-auto">
          <Spinner />
        </div>
      </div>
    )
  }

  return <>{children}</>
}
